export class CallCenterQueryPaginatedDTO {
  offset?: number;
  limit?: number;
  filter?: string;
  order?: string;
}
